<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Fornecedores" exibeVoltar="true" historyback="true"/>
        </div>
		<div class="app-centro">
            <table class="table" cellpading="0" cellspacing="0">
                <tr>
                    <td class="label-cadastro">Nome:</td>
                    <td class="campo-cadastro"> {{fornecedor.NOME_FORNECEDOR}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Endereço:</td>
                    <td class="campo-cadastro"> {{fornecedor.ESTADO}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Cidade:</td>
                    <td class="campo-cadastro"> {{fornecedor.CIDADE}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Email:</td>
                    <td class="campo-cadastro"> {{fornecedor.EMAIL}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Telefone:</td>
                    <td class="campo-cadastro"> {{fornecedor.TEL}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Fax:</td>
                    <td class="campo-cadastro"> {{fornecedor.FAX}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Celular:</td>
                    <td class="campo-cadastro"> {{fornecedor.CELULAR}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Observações:</td>
                    <td class="campo-cadastro"> {{fornecedor.OBS}} </td>
                </tr>

            </table>      
        </div>
		<div class="app-rodape">
            <center>
                <div class="opcoes-fornecedor-item" @click="contatos"><button>Contatos</button></div>
            </center>
        </div>
	</div>


</template>

<script>

import TopBar from '@/components/layout/TopBar.vue';

export default {

    name: 'Fornecedores',
    props: ['id'],
    components: {
        TopBar
    },

    data() {
        return {
            fornecedor : {}
        };        
    },
    mounted: function () {
        const codfornecedor = JSON.parse(atob(this.id));
        const filterFornecedores = this.$store.state.fornecedores.filter(f => {
            return f.COD_FORNECEDOR === codfornecedor
        });
        if (filterFornecedores.length===1)
        this.fornecedor = filterFornecedores[0]
    },

    methods : {

        contatos(){
            var objb64 = btoa(JSON.stringify(this.fornecedor.COD_FORNECEDOR));
            this.$router.push(`/contatosfornecedor/${objb64}`);
        }

    }

}
</script>

<style scoped>
    .table{
        border-collapse: collapse;
        width: calc(100% - 20px);
        margin: 20px 10px;    
        border: 1px solid var(--dark-color);    
    }

    td{
        border: 1px solid var(--dark-color);
    }

    .opcoes-fornecedor{
        width: 100%;
        height: 64px;
        padding-left: 4%;
        padding-left: 4%;
    }
    
    .opcoes-fornecedor-item{
        width: 50%;
        float: center;
        text-align: center;
    }

    .opcoes-fornecedor-item button{
        background-color: var(--primary-color);
        color: white;
        border: 0px;
        height: 44px;
        margin: 10px auto;
        width: 100%;
        border-radius: 10px;
    }


</style>